"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixComponentsShader = void 0;
const gl_shader_1 = require("../gl-shader");
/**
 * @public
 * Component-wise mix on vec2.
 */
// language=GLSL
exports.mixComponentsShader = new gl_shader_1.GlShader(
// @formatter:off
`
#ifndef MIX_COMPONENTS

#define MIX_COMPONENTS 1

vec2 mixComponents(vec2 a, vec2 b, vec2 factor)
{
    return vec2(
    mix(a.x, b.x, factor.x),
    mix(a.y, b.y, factor.y)
    );
}

#endif
`);
//# sourceMappingURL=mix-components-shader.js.map